import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenCompra/notasCredito';
import GridNotasCredito from './Listado';

const mstp = state => {
    return {
        ...state.notasCredito,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(GridNotasCredito)
